class CareOfProductsSlider {
  static CAROUSEL_STATES = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile'
  };

  static WINDOW_WIDTH_BREAKPOINT = 768;

  constructor(element) {
    this.$element = element;
  }

  init() {
    this.$carouselState = null;
    this.$carouselBlock = this.$element.find('.care-of-products-slider__slider');
    this.$slidesPerRow = this.$element.data('slides-per-row');
    this.$resizeTimeout = null;

    this.onWindowResize();

    window.addEventListener('resize', () => {
      this.onWindowResize();
    });
  }

  initDesktopCarousel() {
    this.$carouselBlock.slick({
      slidesToShow: this.$slidesPerRow,
      slidesToScroll: this.$slidesPerRow,
      infinite: false,
      dots: false
    });

    this.$carouselState = CareOfProductsSlider.CAROUSEL_STATES.DESKTOP;
  }

  initMobileCarousel() {
    const mobileCarousel = new Flickity(this.$carouselBlock[0], {
      cellSelector: '.care-of-products-slider__item',
      prevNextButtons: false,
      pageDots: false,
      selectedAttraction: 0.08,
      friction: 0.8,
      freeScroll: true,
      contain: true
    });

    this.$carouselBlock.data('mobile-carousel', mobileCarousel);
    this.$carouselState = CareOfProductsSlider.CAROUSEL_STATES.MOBILE;

    // iOS smooth scrolling fix
    $(mobileCarousel).on('dragStart.flickity', function( event, pointer ) {
      document.ontouchmove = function (e) {
        e.preventDefault();
      }
    });

    $(mobileCarousel).on('dragEnd.flickity', function( event, pointer ) {
      document.ontouchmove = function (e) {
        return true;
      }
    });
  }

  updateCarouselState(windowWidth) {
    if (
      windowWidth >= CareOfProductsSlider.WINDOW_WIDTH_BREAKPOINT &&
      this.$carouselState !== CareOfProductsSlider.CAROUSEL_STATES.DESKTOP
    ) {
      if (this.$carouselState === CareOfProductsSlider.CAROUSEL_STATES.MOBILE) {
        this.$carouselBlock.data('mobile-carousel').destroy();

        setTimeout(() => {
          this.initDesktopCarousel();
        }, 100);
      } else {
        this.initDesktopCarousel();
      }
    } else
    if (
      windowWidth < CareOfProductsSlider.WINDOW_WIDTH_BREAKPOINT &&
      this.$carouselState !== CareOfProductsSlider.CAROUSEL_STATES.MOBILE
    ) {
      if (this.$carouselState === CareOfProductsSlider.CAROUSEL_STATES.DESKTOP) {
        this.$carouselBlock.slick('unslick');

        setTimeout(() => {
          this.initMobileCarousel();
        }, 100);
      } else {
        this.initMobileCarousel();
      }
    }
  }

  onWindowResize() {
    this.resizeDebounced(window.innerWidth);
  }

  resizeDebounced(windowWidth) {
    clearTimeout(this.$resizeTimeout);

    this.$resizeTimeout = setTimeout(() => {
      this.updateCarouselState(windowWidth)
    }, 50);
  }

}